var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('md-card',[_c('md-card-content',[_c('bar-chart',{attrs:{"chart-data":_vm.chartData,"title":_vm.$t('assignment_overall.toefl_component_scores'),"ticks-config":_vm.ticksConfig}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }